import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckoutBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { includedItems } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Section 12 — what the system includes, then the price and the checkout button. */
export function OfferStackSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-141" data-mp="vkja7u1yoml1">
      <div className="mx-auto max-w-5xl overflow-hidden rounded-[32px] bg-white shadow-[0_60px_120px_-60px_rgba(120,70,80,0.6)]" data-id="element-142" data-mp="15c5sgacpvlxa">
        <div className="grid lg:grid-cols-[1fr_1.05fr]" data-id="element-143" data-mp="1jc84hfycfl4m">
          <div className="flex flex-col justify-center bg-brand-champagne px-6 py-10 sm:px-10" data-id="element-144" data-mp="1j9m0fqanvnr5">
            <h2 id="offer-heading" className="text-center font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem] lg:text-left" data-id="element-145" data-mp="1f8imj9c6c1sk">
              Everything You Get <Accent data-id="element-146" data-mp="3hdalt7ov52q2">Today</Accent>
            </h2>
            <img src={MOCKUP_URL} alt="Brow Instructor Ready — the complete system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-8 block w-full max-w-[480px] object-contain" style={{
            filter: 'drop-shadow(0 22px 26px rgba(120, 96, 56, 0.22))'
          }} data-id="element-147" data-mp="3helpl7ib6ah6" />
          </div>

          <ul className="px-6 py-8 sm:px-10 lg:py-10" role="list" data-id="element-148" data-mp="4xq3zv7dpsq8">
            {includedItems.map(item => <li key={item.name} className="flex items-start gap-4 border-b border-brand-charcoal/10 py-4 last:border-b-0" data-id="element-149" data-mp="dw23kmq840ut">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-sage" data-id="element-150" data-mp="ivesre4khk0k">
                  <CheckIcon className="h-3.5 w-3.5 text-brand-cta-dark" strokeWidth={2.75} aria-hidden="true" data-id="element-151" data-mp="2foq9x4y5z4et" />
                </span>
                <span data-id="element-152" data-mp="2kocopitn4spq">
                  <span className={`block leading-snug text-brand-charcoal ${item.primary ? 'font-body text-[14px] font-bold uppercase tracking-[0.06em] sm:text-[15px]' : 'font-display text-[1.25rem] font-semibold'}`} data-id="element-153" data-mp="2clkb0f8ynpkd">
                    {item.name}
                  </span>
                  <span className="mt-0.5 block text-[13px] text-brand-charcoal/55" data-id="element-154" data-mp="2vk66nelpkogw">{item.detail}</span>
                </span>
              </li>)}
          </ul>
        </div>

        <div className="border-t border-brand-charcoal/8 px-6 py-12 sm:px-10" data-id="element-155" data-mp="35a7wobxmggyg">
          <CheckoutBlock label="Yes! I Want Brow Instructor Ready™" data-id="element-156" data-mp="35cbymobyn5w3" />
        </div>
      </div>
    </section>;
}